<link
  rel="stylesheet"
  href="https://unpkg.com/leaflet@1.6.0/dist/leaflet.css"
  integrity="sha512-xwE/Az9zrjBIphAcBb3F6JVqxf46+CDLwfLMHloNu6KEQCAWi6HcDUbeOfBIptF7tcCzusKFjFw2yuvEpDL9wQ=="
  crossorigin=""
/>

<header class="dialog-header">
  <h3 class="header-heading">
    {{ 'components.request.detail.heading' | translate }}
    <div class="loading-spinner" *ngIf="loading">
      <mat-progress-spinner
        mode="indeterminate"
        diameter="20">
      </mat-progress-spinner>
    </div>
  </h3>
  <button 
    class="close-button" 
    (click)="closeDialog()"
  ></button>
</header>
  
<div class="content">
  <div class="table-wrapper">
    <table mat-table [dataSource]="!!request ? [request] : []">

      <ng-container matColumnDef="isPublic">
        <th mat-header-cell *matHeaderCellDef>{{ 'components.request.detail.table.header.isPublic' | translate }}</th>
        <td mat-cell *matCellDef="let element">
          <span *ngIf="element.isPublic" class="icon icon-family"></span>
          <span else class="icon icon-view-off"></span>
        </td>
      </ng-container>

      <ng-container matColumnDef="requestNum">
        <th mat-header-cell *matHeaderCellDef>{{ 'components.request.detail.table.header.requestNum' | translate }}</th>
        <td mat-cell *matCellDef="let element">
          {{ element?.requestNum }}
        </td>
      </ng-container>

      <ng-container matColumnDef="userName">
        <th mat-header-cell *matHeaderCellDef>{{ 'components.request.detail.table.header.userName' | translate }}</th>
        <td mat-cell *matCellDef="let element">
          {{ element?.user?.firstName }} {{ element?.user?.lastName }}
        </td>
      </ng-container>

      <ng-container matColumnDef="category">
        <th mat-header-cell *matHeaderCellDef>{{ 'components.request.detail.table.header.category' | translate }}</th>
        <td mat-cell *matCellDef="let element">
          {{ element?.category?.name }}
        </td>
      </ng-container>

      <ng-container matColumnDef="updated_at">
        <th mat-header-cell *matHeaderCellDef>{{ 'components.request.detail.table.header.updated_at' | translate }}</th>
        <td mat-cell *matCellDef="let element">
          {{ dateToString(element.updated_at) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>{{ 'components.request.detail.table.header.status' | translate }}</th>
        <td mat-cell *matCellDef="let element">
          {{ 'common.request.request.status.' + element?.status | translate }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

    </table>
  </div>

  <div class="description">
    <h5>{{ 'components.request.detail.label.subject' | translate }}</h5>
    <p>{{ request?.subject?.name }}</p>
    <h5>{{ 'components.request.detail.label.description' | translate }}</h5>
    <p>{{ request?.description }}</p>

    <div *ngIf="request?.address?.street && request?.address?.number">
      <h5>{{ 'components.request.detail.label.address' | translate }}</h5>

    
      <p>
        <span *ngIf="request?.address?.unit">{{ request?.address?.unit }} </span> <span>{{ request?.address?.number }} {{ request?.address?.street }}</span>
        <span *ngIf="request?.address?.city">, {{ request?.address?.city }}</span>
        <span *ngIf="request?.address?.province">, {{ request?.address?.province }}</span>
        <span *ngIf="request?.address?.province">, {{ request?.address?.postCode }}</span>
        <br /> 
        <span class="requests-from-geopos" *ngIf="request?.address?.latitude && request?.address?.longitude && request.address.fromGeoposition">
          {{ 'components.request.detail.label.addressFromGeopos' | translate }}
        </span>
      </p>
  </div>

  <div class="map">
    <h5>{{ 'components.request.detail.label.map' | translate }}</h5>
    <div id="noLngLat" *ngIf="!request?.address?.latitude && !request?.address?.longitude">
      {{ 'components.request.detail.label.noLngLat' | translate }}
    </div>
    <div class="requests-map-container" [hidden]="!request?.address?.latitude && !request?.address?.longitude">
      <div class="requests-map-frame">
        <div id="requests-map"></div>
      </div>
    </div>
  </div>

  <div class="attachments" *ngIf="request?.linkedPieces?.length > 0">
    <h5>{{ 'components.request.detail.label.attachments' | translate }}</h5>
    <div class="images-container">
      <div *ngFor="let img of request?.linkedPieces" 
       class="image" 
       [ngStyle]="{'background-image': 'url(' + img +')'}"
       (click)="viewImage(img)">
      </div>
    </div>
  </div>
</div>

<footer class="dialog-footer">
  <button
    (click)="closeDialog()" 
    class="bciti-button bciti-button--blue">
    {{ 'common.request.button.close' | translate }}
  </button>
</footer>